"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VIEW_EVENT = 8000;
exports.CLICK_EVENT = 8001;
exports.LOAD_EVENT = 8002;
exports.BANNER_INIT = 8003;
exports.BANNER_RENDERED = 8004;
//# sourceMappingURL=bi-events.js.map